<template>
    <div class="menu-child-box">
        <div class="menu-child-item" v-for="(v, idx) in child" :key="idx">
            <a class="menu-child-item-box" :href="v.href" @click="$emit('hide')">
                <img class="menu-child-icon" :src="'static/icon/menu_icon/' + v.icon" />
                <p class="menu-child-name">{{ v.name }}</p>
                <img class="arrow-icon" v-if="v.child" src="static/icon/arrow_right_blue.svg" />
            </a>
            <div class="menu-child-base" v-if="v.child">
                <comp-menu-child :child="v.child" @hide="$emit('hide')"></comp-menu-child>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'

export default defineComponent({
    name: "comp-menu-child",
    props: {
        child: {
            type: Array as PropType<any[]>,
            required: true
        }
    },
    emits: ['hide']
})
</script>